/* Slow editorial marquee band. */
export default function Marquee({ text = "Smart Dismissal. Safer Schools.", dark = false, repeat = 6 }) {
  const items = Array.from({ length: repeat });
  return (
    <div
      className={`relative overflow-hidden border-y py-6 ${
        dark ? "border-white/10 bg-obsidian text-white" : "border-ink/10 bg-bone text-ink"
      }`}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {[0, 1].map((group) => (
          <div key={group} className="flex" aria-hidden={group === 1}>
            {items.map((_, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display text-3xl font-800 tracking-tight md:text-5xl">{text}</span>
                <span className="mx-8 text-leaf md:mx-12">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" className="inline-block">
                    <path d="M12 2l2.4 7.2H22l-6.2 4.5L18.2 21 12 16.4 5.8 21l2.4-7.3L2 9.2h7.6L12 2z" fill="currentColor" />
                  </svg>
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
